<template>
  <div>
    <div id="print">
      <div class="cons_topname">
        <center><h4>典当折价（估价）协议</h4></center>
      </div>
      <div class="titles">
        <span>
          甲方（典当行）： <u>{{ $store.state.name }}</u></span
        >
        <span>
          乙方（当户）：<u>{{ msgVal.name }}</u>
        </span>
      </div>
      <div>
        <p>
          &nbsp;&nbsp;甲乙建立典当业务关系，就乙提交的当物折价（估价）事宜，依据《典当管理办法》规定及《中国银保监会办公厅关于加强典当行监督管理的通知》要求，双方协商达成以下协议：
        </p>
        <span>
          <h5>第一条 折价当物</h5>
        </span>
        <span>
          当物名称：<u>汽车/车牌号-{{ msgVal.plateNumber }}</u>
        </span>
        <span>
          <h5>第二条 乙方声明和保证</h5>
        </span>
        <span> 乙对当物享有完全的所有权；当物来源合法，乙方有合法处分权。 </span>
        <span>
          <h5>第三条 折价估值金额</h5>
        </span>
        <span>
          考虑到车辆折损贬值，以及存在担保负债等情况下，双方同意上述当物典当估值人民币
          <u>{{ msgVal.sum }}</u> 元。
        </span>
        <span>
          <h5>第四条 协议折价变卖</h5>
        </span>
        <span>
          典当期限届满，乙既不续当又不赎当，导致当物绝当。甲乙同意不通过第三方拍卖机构委托拍卖，同意以估值金额、协议折价变卖的方式及时处理以上典当绝当物，所得价款优先偿还典当本金、综合费用、典当利息、实现债权产生的全部费用，剩余部分应当退还乙，不足部分甲应继续向乙追偿。因甲向乙追偿产生实现债权费用（仲裁、诉讼受理费以及诉讼代理律师费）由乙承担。
        </span>
        <span> 本协议经双方签字或盖章后生效。 </span>
        <span> 协议一式两联，甲乙各持一联。 </span>
      </div>
      <div class="footer_a">
        <div class="footer">
          <span>甲 方（签章）：</span>
          <span>乙 方（签字）：</span>
        </div>

        <div class="footer">
          <div class="footer_d"><span>年</span> <span>月</span><span>日</span></div>
          <div class="footer_d"><span>年</span> <span>月</span><span>日</span></div>
        </div>
      </div>
    </div>
    <div class="bTn">
      <button v-print="'#print'">打印合同</button>
      <!-- <el-button type="primary">打 印 合 同</el-button> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "DisCount",
  props: ["msgVal"],
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
.titles {
  display: flex;
  flex-direction: column;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.footer_d {
  width: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.bTn {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.footer_a {
  margin-top: 30px;
}
</style>
